import { useApi } from '@core/api'
import { minute } from '@core/constants/timeouts'
import { useQuery } from '@tanstack/react-query'

import type { AiModel } from './author-types'

export const authorKeys = {
  aiModelList: ['author', 'ai-models'],
  aiCombinedList: ['ai-models-combined'],
  profileOneList: ['author-v2', 'profile'],
}

export function useAiModels<TData>(options: {
  select: (data: AiModel[]) => TData
}): ReturnType<typeof useQuery<AiModel[], Error, TData>>
export function useAiModels(): ReturnType<typeof useQuery<AiModel[], Error, AiModel[]>>
export function useAiModels<TData = AiModel[]>(options?: { select?: (data: AiModel[]) => TData }) {
  const api = useApi()

  return useQuery({
    queryKey: authorKeys.aiModelList,
    queryFn: async () => {
      const response = await api.listAiModels({ throwOnError: true })
      return response.data as unknown as AiModel[]
    },
    select: options?.select,
    staleTime: minute * 5,
  })
}
